module.exports = __webpack_public_path__ + "static/media/warning.98f47b33.png";